import { bootInstance } from "./instance.js";

function bootAll() {
  document.querySelectorAll(".lgpxp").forEach((root) => bootInstance(root));
}

document.addEventListener("DOMContentLoaded", bootAll);
